const en = {
    logout: 'LogOut',
    mypage: 'My Page',
    login: 'LogIn',
    registraion: 'SignUp',
    addNewAddBtnName: 'Place an ad',
    mainPage: 'Main Page',
    favoritesBtn: 'Favorites',
    myMessagesBtn: 'My Messages',
}

const rus = {
    logout: 'Выйти из приложения',
    mypage: 'Моя страница',
    login: 'Войти',
    registraion: 'Зарегистрироваться', 
    addNewAddBtnName: 'Добавить объявление',
    mainPage: 'Главная страница',
    favoritesBtn: 'Избранное',
    myMessagesBtn: 'Мои сообщения',
}

const hebrew = {
    logout: 'להתנתק',
    mypage: 'העמוד שלי',
    login: 'התחברות',
    registraion: 'רישום',
    addNewAddBtnName: 'פרסם מודעה',
    mainPage: 'דף הבית',
    favoritesBtn: 'מועדפים',
    myMessagesBtn: 'הודעות שלי',
}

const choose = { en, rus, hebrew };

export default choose;
